<template>
  <v-footer
    v-if="!isAuthenticated()"
    location="bottom"
    :app="true"
    variant="tile"
    :hide-on-scroll="true"
    density="comfortable"
    color="var(--color-brand-400)"
    tile
  >
    <v-row justify="space-between">
      <v-col cols="8">
        <span style="color: var(--color-brand)">
          {{ $t('footer.notloggedin') }} v{{ getEnv() }}
        </span>
      </v-col>
      <v-col cols="3">
        <div style="color: var(--color-brand)">
          &copy; Hypatia Learning AS
        </div></v-col
      >
    </v-row>
  </v-footer>
  <v-footer
    v-else
    location="bottom"
    :app="true"
    variant="tile"
    density="compact"
    :hide-on-scroll="true"
    color="var(--color-brand-200)"
  >
    <!-- IS AUTHENTICATED -->
    <v-toolbar-items>
      <div class="nametext" :title="loggedInAs() + schoolInfo()">
        {{ loggedInAs() }}
        {{ schoolInfo() }}
      </div>
    </v-toolbar-items>
    <v-spacer />
    <v-toolbar-items>
      <LanguageChooser />
      <span class="copyright">&copy; Hypatia Learning AS v{{ getEnv() }}</span>
    </v-toolbar-items>
  </v-footer>
</template>

<script>
import adminStore from '@/stores/adminstore'
import { mapActions, mapGetters } from 'pinia'

import app from '../../../package.json'
import LanguageChooser from './LanguageChooser.vue'

export default {
  name: 'FooterMenu',
  // props: ['auth', 'authenticated'],
  components: {
    LanguageChooser
  },
  data() {
    return {}
  },
  mounted() {},
  beforeMount() {},
  methods: {
    ...mapActions(adminStore, []),
    ...mapGetters(adminStore, [
      'getLoggedIn',
      'getDisplayName',
      'getEnvironment',
      'getBGroups',
      'getOrgGroups'
    ]),
    isAuthenticated() {
      let isLoggedIn = this.getLoggedIn()
      if (isLoggedIn !== undefined && isLoggedIn) {
        return true
      }
      return false
    },
    loggedInAs() {
      var displayName = this.getDisplayName()
      if (
        this.isAuthenticated() &&
        displayName !== undefined &&
        displayName !== ''
      ) {
        return displayName
      }
      return '[NOT LOGGED IN]'
    },
    schoolInfo() {
      let bGroups = this.getBGroups()
      let orgGroups = this.getOrgGroups()
      if (bGroups[0] !== undefined && orgGroups[1] !== undefined) {
        return ' - ' + bGroups[0].displayName + ' - ' + orgGroups[1].displayName
      } else {
        return ''
      }
    },
    getEnv() {
      return app.version
    }
  }
}

/*
function get3DigitLangCode(lang2) {
  switch (lang2.toLowerCase()) {
    case 'nb':
      return 'nob'
    case 'nn':
      return 'nno'
    case 'en':
      return 'eng'
    case 'no':
      return 'nob'
    case 'se':
      return 'sme'
    default:
      return 'eng'
  }
}
*/
</script>

<style lang="css">
.footer {
  text-align: left;
  font-size: calc(0.6em + 1vmin);
  color: rgb(100, 100, 100);
}

.footerinfo {
  text-align: left;
  font-size: calc(0.6em + 1vmin);
  margin-left: 10px;
  margin-right: 10px;
  color: rgb(100, 100, 100);
}

.languagechooser {
  text-align: left;
  font-size: calc(0.6em + 1vmin);
  margin-left: 20px;
  color: rgb(100, 100, 100);
}

.hostinfo {
  padding-left: 20px;
  text-align: left;
  font-size: calc(0.6em + 0.7vmin);
  color: rgb(100, 100, 100);
}

.domainserver {
  padding-left: 10px;
  font-size: calc(0.3em + 0.3vmin);
  color: rgb(100, 100, 100);
}

.nametext {
  min-width: 0;
  max-width: 60vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.9rem;
  font-weight: 400;
  text-transform: capitalize;
  padding-left: 2vw;
  color: var(--color-white);
}

.copyright {
  white-space: nowrap;
  font-size: 0.8rem;
  color: var(--color-white);
  padding-right: 3vw;
  padding-left: 1vw;
}
</style>
